import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Sites() {
  const navigate = useNavigate();

  const [siteId, setSiteId] = useState("");

  const goToLocations = () => {
    if (!siteId || siteId === "") return;
    else navigate(`./${siteId}`);
  };

  return (
    <>
      <div className="vh-100 d-flex flex-column justify-content-center align-items-center">
        <h1 className="welcome text-center">
          Welcome!
          <br />
          <b>Enter your Site ID</b>
        </h1>
        <div className="mt-5 d-flex flex-row justify-content-evenly align-items-center">
          <form className="row g-3" autoComplete="off">
            <div className="col-auto">
              <label htmlFor="inputPassword2" className="visually-hidden">
                Site ID
              </label>
              <input
                className="form-control form-control-lg"
                data-testid="site-id-input"
                placeholder="Site ID"
                value={siteId}
                onChange={(e) => setSiteId(e.target.value)}
                autoComplete="off"
                onKeyUp={(e) => {
                  if (e.key === "Enter") goToLocations;
                }}
              />
            </div>
            <div className="col-auto">
              <button
                type="submit"
                className="btn btn-secondary btn-lg mb-3"
                data-testid="site-id-submit-btn"
                onClick={goToLocations}
              >
                GO
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
